import type { DataSourcePropFilterValue } from "@infinite-table/infinite-react";
import type { FilterCondition, FilterParams } from "epsm-api-types";
import type { NewsRaw } from "epsm-api-types/models";
import { mapFilterOperator } from "@/lib/utils";
import { NEWS_COLUMNS } from "../../../types";

export const HOT_SIGNIFICANCY_VALUE = 6;
export const DEFAULT_SENTIMENT = 3;
export const INVALID_SENTIMENT_FALLBACK_VALUE = 100;

export function getTransformedFilterByEstimate(
	filterValue?: DataSourcePropFilterValue<NewsRaw>,
): FilterParams {
	if (!filterValue?.length) return [];

	const sentimentFilters = filterValue.filter(
		({ field }) => field === NEWS_COLUMNS.SENTIMENT,
	);

	if (!sentimentFilters.length) return [];

	let newFilters =
		sentimentFilters?.flatMap(({ field, filter }) =>
			filter?.value != null
				? [{ name: field as string, ...mapFilterOperator(filter) }]
				: [],
		) ?? [];

	const sentimentIndex = newFilters.findIndex(
		(el) => "name" in el && el.name === NEWS_COLUMNS.SENTIMENT,
	);

	if (sentimentIndex !== -1) {
		const sentiment = newFilters[sentimentIndex];

		if ("value" in sentiment) {
			const sentimentValue = (sentiment.value as string)?.toLowerCase();

			let condition: FilterCondition | null = null;
			let value: number | null = null;

			const sentimentMapping: Record<string, FilterCondition> = {
				"\\+\\+": "gt",
				"\\+": "gt",
				"\\-\\-": "lt",
				"\\-": "lt",
			};

			if (sentimentValue in sentimentMapping) {
				condition = sentimentMapping[sentimentValue];
			}

			if (condition) {
				value = DEFAULT_SENTIMENT;
			}

			if (condition && value !== null) {
				sentiment.condition = condition;
				sentiment.value = value;

				const significanceCondition =
					sentimentValue === "\\-" || sentimentValue === "\\+" ? "lt" : "gte";

				newFilters.push({
					name: NEWS_COLUMNS.SIGNIFICANCY,
					condition: significanceCondition,
					value: HOT_SIGNIFICANCY_VALUE,
				});

				if ("options" in sentiment) {
					const { options: _options, ...cleanedSentiment } = sentiment;

					newFilters[sentimentIndex] = cleanedSentiment;
				}
			} else {
				newFilters.push({
					name: NEWS_COLUMNS.SIGNIFICANCY,
					condition: "gte",
					value: INVALID_SENTIMENT_FALLBACK_VALUE,
				});

				newFilters = newFilters.filter(
					(el) => !("name" in el) || el.name !== NEWS_COLUMNS.SENTIMENT,
				);
			}
		}
	}

	return newFilters;
}
